<app-base-modal
  [title]="'Карточка блогера'"
  [modalMaxHeight]="'95vh'"
>
  @if (isLoading) {
    <app-loader/>
  }
  @if (hasBlogger()) {
    <app-current-blogger-profile-modal
      [bloggerCardHeader]="bloggerCardHeader() || defaultRecordData"
      [bloggerDialogData]="bloggerDialogData"
      [bloggerPropertiesParams]="bloggerPropertiesParams()"
      (initBloggerCardHeader)="initBloggerCardHeader($event)"
    />
  } @else {
    <app-new-blogger-profile-modal
      [bloggerFormGroup]="bloggerFormGroup"
      [bloggerDialogData]="bloggerDialogData"
      (initBloggerCardHeader)="initBloggerCardHeader($event)"
      (toggleLoadingState)="toggleLoadingState($event)"
      (handleCloseModal)="closeDialog($event)"
    />
  }
</app-base-modal>

